import { render, staticRenderFns } from "./OrderSingleAppliedDiscounts.vue?vue&type=template&id=289efb9e&"
import script from "./OrderSingleAppliedDiscounts.vue?vue&type=script&lang=js&"
export * from "./OrderSingleAppliedDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports